import React, { useState, useEffect } from "react";
import axios from "axios";
import { getAppointments } from "../../backendServices/appointmentService";
import { Box, Button, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

import AdminDashboard from "./admin/AdminDashboard";
import UserDashboard from "./userDashboard/UserDashboard";
import { getUserRole } from "../../backendServices/RequireAuth";
import { t } from "i18next";

const Dashboard = ({ token }) => {
  const [role, setRole] = useState(null); // Initialize role as null to differentiate uninitialized state

  useEffect(() => {
    const fetchRole = async () => {
      try {
        // Fetch role from backend
        if (token) {
          const roleResponse = await getUserRole(token); // Ensure this function returns a valid role
          console.log("Fetched Role:", roleResponse); // Debugging: Check the role being returned
          setRole(roleResponse); // Update the state with the role
        }
      } catch (error) {
        console.error("Error fetching user role:", error.message);
      }
    };

    // if (token) {
    fetchRole(); // Fetch role only if a token exists
    // }
  }, [token]);

  console.log("user role : ", role);

  // Refresh handler to reload the current state
  const handleRefresh = async () => {
    try {
      console.log("Refreshing dashboard...");
      window.location.reload(true);
      const updatedRole = await getUserRole(token); // Re-fetch user role
      setRole(updatedRole); // Update role
    } catch (error) {
      console.error("Error refreshing role:", error.message);
    }
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        width: "100%",
        minHeight: "100vh",
        p: 3,
        pt: 9,
        position: "relative", // Positioning for the refresh button
      }}
    >
      <button
        // variant="outlined"
        // color="primary"
        onClick={handleRefresh}
        style={{
          position: "absolute", // Position at the top-left
          top: 100,
          right: 10,
          zIndex: 1000, // Ensure it appears above other elements
          // width: "10px",
          padding: "5px",
          border: "none",
          borderRadius: "50%",
          backgroundColor: "var(--primary)",
        }}
      >
        {/* sx={{ position: "absolute", top: 10, left: 10 }} */}
        {/* > */}
        <RefreshIcon sx={{ color: "var(--dark)", fontSize: "40px" }} />
      </button>

      <Typography variant="h4" component="h1" gutterBottom align="center">
        {t("dashboard")}
      </Typography>

      {role === null ? (
        <p> loading...</p>
      ) : role === 1 || role === 2 ? (
        <AdminDashboard token={token} />
      ) : (
        <UserDashboard token={token} />
      )}
    </Box>
  );
};

export default Dashboard;
